<div class="container flex column" *ngIf="vm">
  <div class="header flex row">
    <h2>Pick day and time</h2>
  </div>
  <div class="body  flex column">
    <div class="flex row field">
      <icn-day-of-week-picker [overrideStyle]="{'width': '10vw'}" [selectedDay]="vm.dayOfWeek" (onChange)="vm.dayOfWeek = $event"></icn-day-of-week-picker>
    </div>
    <div class="flex row field">
      <icn-time-picker
        [overrideStyle]="{'text-align': 'center'}"
        class="time-picker"
        [(timeInMinutes)]="vm.selectedTimeInMinutes"
      ></icn-time-picker>
    </div>
  </div>
  <div class="actions  flex row">
    <button (click)="vm.onApplyClickedHandler(vm)" class="apply-btn">APPLY</button>
  </div>
</div>
